import React from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'

const BulkConfirmationTickets = ({ hidden, tickets }) => {

  if (hidden) {
    return null
  }

  return (
    <div className="flex flex--centered flex--columned text-aligned-center">
      <div className="flex">
        <span className="lnr lnr-checkmark-circle lnr--green lnr--large" style={{ fontSize: '30px' }} />
        {_.map(tickets, (ticket) => {
          return (
            <>
              <h2 style={{ fontWeight: '600', margin: 0, marginLeft: '10px', marginBottom: '10px'}}>
                {`Ticket #${ticket} Created.`}
              </h2>
              <br />
            </>
          )
        })}
      </div>
      <p>
        Please check your email for a link to your support ticket.
      </p>
    </div>
  )
}

BulkConfirmationTickets.propTypes = {
  hidden: PropTypes.bool
}

BulkConfirmationTickets.defaultProps = {
  hidden: false
}

export default BulkConfirmationTickets
